module.exports = __webpack_public_path__ + "images/giftTree/christmas.8db012747ad7f1854ad2908a331f3b96.png";